module.exports = __webpack_public_path__ + "static/media/volunteering-cuate.92e1296d.svg";